export const AboutMe = () => {
  return (
    <div className="site-header w-90p m-auto">
      <h1 className="title h1 m-b-2">
        Hi, I'm <span className="colored-text h1 bg">Neha Gupta.</span>
      </h1>
      <p className="m-v-1">
        <strong className="h3"> A passionate full stack developer from Delhi, India.</strong>
      </p>
      <p>
        {" "}
        I build Web applications with <strong>ReactJS | Angular | JavaScript | TypeScript | Node.js</strong> and other
        cool libraries and frameworks. You can find my work on{" "}
        <a href="https://github.com/nayyyhaa" target="_blank">
          Github
        </a>
        ,{" "}
        <a href="https://codesandbox.io/u/nayyyhaa" target="_blank">
          CodeSandBox
        </a>{" "}
        and{" "}
        <a href="https://instagram.com/nehacode" target="_blank">
          Instagram
        </a>
        . I also love to document my journey, so you'll find me posting on{" "}
        <a href="https://twitter.com/nayyyhaa" target="_blank">
          Twitter
        </a>
        . If you would like to work with me, drop me an <a href="mailto:nehaguptang.ng@gmail.com">email</a>.
      </p>
    </div>
  );
};
